<template>
  <div class="select_list">
    <div>
      <div class="select_input">
        <span class="select_label">设备系统：</span>
        <el-select v-model="valueDevice" placeholder="请选择" @change="valueDeviceChange">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="select_input">
        <span class="select_label">风险标签：</span>
        <el-select v-model="valueTag" placeholder="请选择">
          <el-option
            v-for="item in optionsTag"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="select_input">
        <span class="select_label">风险等级：</span>
        <el-select v-model="valueGrade" placeholder="请选择">
          <el-option
            v-for="item in $constants.CATEGORY_RISKLEVEL"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div>

      <div class="select_input">
        <span class="select_label">token：</span>
        <el-input v-model="input" placeholder="请填写token"></el-input>
      </div>
      <div class="select_input">
        <span class="select_label">访问时间：</span>
        <el-date-picker
          size="small"
          v-model="valueTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="select_btn">
      <el-button type="primary" @click="searchFingerPrint">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>
    <loading v-show='isSearch' marginTop='100px'></loading>
    <div class="select_table" v-show='!isSearch'>
      <table style="border-collapse:collapse;">
        <tr>
          <th width="18%">查询时间</th>
          <th>设备指纹</th>
          <th width="10%">设备系统</th>
          <th>风险标签</th>
          <th width="12%">风险等级</th>
          <th width="12%">风险分数</th>
        </tr>
        <tr v-for="(item,index)  in data" :key="index">
          <td>{{new Date(item.create_time).toLocaleString()}}</td>
          <td>{{item.device_fingerprint}}</td>
          <td>{{item.source}}</td>
          <td>
            <p v-show="item.tags.length>0 && listTag.find((option) => option.value === tag)"
               v-for="(tag,i) in item.tags" :key="i"
               style="line-height: 30px;"><span
              style="background:#FFB200;padding: 3px 10px;color: #fff;border-radius: 12px;">{{listTag.find((option) => option.value === tag)? listTag.find((option) => option.value === tag).label:''}}</span>
            </p>
          </td>
          <td>{{$constants.CATEGORY_RISKLEVEL.find((option) => option.value === item.risklevel).label}}</td>
          <td>{{item.score}}</td>
        </tr>
      </table>
      <p class="no_data" v-if="data.length ===0 && !isSearch">暂无数据</p>
      <div v-if="data.length>0 && pages>1" class="page" style="text-align: center;margin-top: 20px;">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" background
                       layout="prev, pager, next, jumper" :page-count="pages">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import Loading from '../../../components/loading/loading'
import { getFingerPrintList, getFingerPrintDeviceTag } from '../../../services/interface'
import { gte, lte } from '../../../util/filters'

export default {
  components: {
    Loading
  },
  data () {
    return {
      currentPage: 1,
      page: 1,
      pageSize: 10,
      pages: 1,
      isSearch: false,
      options: [],
      valueGrade: null,
      valueDevice: '',
      optionsTags: {},
      optionsTag: [],
      listTag: [],
      optionsAll: [
        {
          value: null,
          label: '全部'
        }
      ],
      valueTag: null,
      valueTime: '',
      data: [],
      filter: {},
      input: '',
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() || time.getTime() < Date.now() - 7776000000
        }
      }
    }
  },
  mounted () {
    this.getDeviceTag()
  },
  methods: {
    valueDeviceChange (val) {
      console.log(val)
      this.optionsTag = this.optionsAll.concat(this.optionsTags[val])
      this.valueTag = null
    },
    handleCurrentChange (page) {
      this.page = page
      this.getData()
    },
    // 获取数据
    async getData () {
      this.isSearch = true
      const data = {
        page: this.page,
        pageSize: this.pageSize,
        'create_time:ordering': 'desc'
      }
      const res = await getFingerPrintList({ ...data, ...this.filter })
      console.log(res.data.status)
      if (res.data.status === 200) {
        this.isSearch = false
        this.data = res.data.data
        this.pages = res.data.page_count
      } else {
        this.isSearch = false
        this.$message.error(res.data.errmsg)
        this.data = []
      }
    },
    // 查询
    searchFingerPrint () {
      const filter = {
        tags: this.valueTag,
        source: this.valueDevice,
        risk_level: this.valueGrade
      }
      filter.token = this.input
      if (this.valueTime) {
        filter[gte('create_time')] = this.valueTime[0].toISOString()
        filter[lte('create_time')] = this.valueTime[1].toISOString()
      }
      this.filter = filter
      this.page = 1
      this.currentPage = 1
      const tag = this.optionsTag.concat()
      this.listTag = tag
      this.getData()
    },
    // 重置
    reset () {
      this.valueTag = null
      this.valueGrade = null
      this.input = ''
      this.valueTime = ''
    },
    // 获取标签
    async getDeviceTag () {
      const res = await getFingerPrintDeviceTag()
      console.log(res)
      if (res.status === 200) {
        console.log(res.data)
        this.optionsTags = res.data.data
        for (const name in this.optionsTags) {
          this.options.push({
            value: name,
            label: name
          })
        }
        this.valueDevice = Object.keys(this.optionsTags)[0]
        this.optionsTag = this.optionsAll.concat(this.optionsTags[Object.keys(this.optionsTags)[0]])
      }
    }

  },
  computed: {}
}
</script>

<style>
  .select_list {
    background: #fff;
    border-radius: 10px;
    min-height: 500px;
    margin-bottom: 50px;
    padding: 40px 20px;
  }

  .select_list .select_input {
    display: inline-block;
    margin-right: 4%;
    margin-bottom: 20px;
    width: 40%;
    text-align: right;
    min-width: 300px;
  }

  .select_list .select_input:nth-child(3) {
    margin-right: 0;
  }

  .select_list .select_label {
    font-size: 14px;
  }

  .select_list .el-input {
    display: inline-block;
    width: 76%;
    min-width: 167px;
  }

  .select_list .el-pagination__editor.el-input {
    width: 50px;
    min-width: auto;
  }

  .select_list .el-input > input {
    height: 32px;
    line-height: 32px;
  }

  .select_list .el-input__icon {
    line-height: 24px;
  }

  .select_list .el-select {
    width: 76%;
    min-width: 167px;
  }

  .select_list .el-input--suffix {
    width: 100%;
  }

  .select_list .el-range-editor.el-input__inner {
    width: 76%;
  }

  .select_list .select_btn {
    text-align: center;
    margin-top: 10px;
  }

  .select_list .select_btn .el-button {
    height: 32px;
    line-height: 0;
  }

  .select_list .select_table {
    margin-top: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #f2f2f2;
    border-radius: 10px;
  }

  .select_list .select_table > table {
    width: 100%;
    table-layout: fixed;
  }

  .select_list .select_table tr {
    width: 100%;
    height: 40px;
    text-align: left;
    border-radius: 10px;
    word-wrap: break-word;
  }

  .select_list .select_table tr th, .select_list .select_table tr td {
    padding-left: 10px;
    font-size: 14px;
    line-height: 40px;
    color: #606266;
  }

  .select_list .select_table tr td {
    padding: 10px 0 10px 10px;
  }

  .select_list .select_table tr:nth-child(odd) {
    background: #FAFAFA;
  }

  .select_list .select_table tr:nth-child(1) {
    background: #f2f2f2;
    /*color: #fff;*/
  }

  .select_list .no_data {
    width: 100%;
    text-align: center;
    font-size: 14px;
    margin-top: 30px;
    color: #606266;
  }
</style>
